import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AnimatedGridPattern } from '../magicui/animated-grid-pattern';
import { BlurFade } from '../magicui/blur-fade';
import { WordRotate } from '../magicui/word-rotate';
import { ShimmerButton } from '../magicui/shimmer-button';
import FlowCard from '../FlowCard';

export default function Hero() {
  return (
    <section className="relative isolate overflow-hidden bg-white pb-20 pt-32 lg:pb-28 lg:pt-40">
      <AnimatedGridPattern
        numSquares={36}
        maxOpacity={0.12}
        duration={3}
        repeatDelay={1}
        className="-z-10 fill-fusion-blue/40 stroke-ink/[0.07] [mask-image:radial-gradient(900px_circle_at_30%_30%,white,transparent)] skew-y-6 inset-x-0 inset-y-[-30%] h-[160%]"
      />
      <div aria-hidden="true" className="absolute -right-40 top-10 -z-10 size-[36rem] rounded-full bg-gradient-to-br from-fusion-blue/15 via-fusion-violet/10 to-fusion-teal/15 blur-3xl" />

      <div className="container-x grid items-center gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16">
        <div>
          <BlurFade delay={0.05}>
            <p className="eyebrow">Software company · Kyiv, Ukraine</p>
          </BlurFade>
          <BlurFade delay={0.15}>
            <h1 className="mt-6 font-display text-[clamp(2.7rem,6vw,4.9rem)] font-semibold leading-[1.02] tracking-[-0.045em]">
              Software that makes everyday work{' '}
              <WordRotate words={['simpler.', 'faster.', 'private.', 'effortless.']} duration={2600} className="fusion-text pb-1" />
            </h1>
          </BlurFade>
          <BlurFade delay={0.25}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-3">
              Market Fusion Innovations designs and builds focused desktop tools that do one job exceptionally
              well — and respect the people who use them.
            </p>
          </BlurFade>
          <BlurFade delay={0.35}>
            <div className="mt-9 flex flex-wrap items-center gap-3">
              <ShimmerButton as={Link} to="/pdf-flows" background="#0A0F1F" shimmerColor="#7DD3FC" className="gap-2 text-sm font-semibold">
                Explore PDF Flows <ArrowRight className="size-4" aria-hidden="true" />
              </ShimmerButton>
              <Link to="/#company" className="btn-outline">
                About the company
              </Link>
            </div>
          </BlurFade>
        </div>

        <BlurFade delay={0.3} direction="up" offset={20} className="mx-auto w-full max-w-md lg:max-w-none">
          <FlowCard />
        </BlurFade>
      </div>
    </section>
  );
}
